import { Component, OnInit, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { mergeMap, tap } from 'rxjs';
import { IconComponent } from '../icons/icon.component';
import { RoundIconComponent } from '../round-icon/round-icon.component';
import { InputComponent } from '../input/input.component';
import { MaskFieldInputComponent } from '../mask-field-input/mask-field-input.component';
import { AuthService } from '../../core/services/auth.service';
import { AuditService } from '../../core/services/audit.service';
import { ErrorsService } from '../../core/services/errors.service';
import { GiftCard } from '../../core/models/core/gift-card.model';
import { MaskFieldInputType } from '../mask-field-input/mask-field-input-type.enum';
import { IconNameType } from '../icons/icon-name-type.enum';
import { ModalService, ModalName } from '../../core/services/modal.service';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { ToastService } from '../../core/services/toast.service';
@Component({
  selector: 'cwo-add-wallet-modal',
  standalone: true,
  imports: [
    IconComponent,
    InputComponent,
    RoundIconComponent,
    MaskFieldInputComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslocoPipe
  ],
  templateUrl: './add-wallet-modal.component.html',
  styleUrl: './add-wallet-modal.component.scss',
})
export class AddWalletModalComponent implements OnInit {
  modalService = inject(ModalService);
  authService = inject(AuthService);
  auditService = inject(AuditService);
  errorsService = inject(ErrorsService);
 translocoService = inject(TranslocoService);
  toastService = inject(ToastService);
  addGiftCardForm!: FormGroup;
  allErrors?: string[] = [];
  showErrors = false;

  iconNameType = IconNameType;
  maskFieldInputType = MaskFieldInputType;

  validationMessages: any = {
    friendlyName: {
      required: 'Friendly Name is required',
    },
    giftCardNumber: {
      required: 'Number is required',
    },
    pin: {
      required: 'Pin is required',
    },
  };

  ngOnInit(): void {
    this.addGiftCardForm = new FormGroup({
      friendlyName: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      number: new FormControl('', Validators.compose([Validators.required])),
      pin: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  onAddGiftCardFormSubmit() {
    this.showErrors = false;
    this.allErrors = [];

    if (!this.addGiftCardForm.valid) {
      this.showErrors = true;
      return;
    }

    if (
      this.addGiftCardForm.value.friendlyName &&
      this.addGiftCardForm.value.number &&
      this.addGiftCardForm.value.pin
    ) {
      const newGiftCard = new GiftCard();
      newGiftCard.addToAccount = true;
      newGiftCard.friendlyName = this.addGiftCardForm.value.friendlyName;
      newGiftCard.number = this.addGiftCardForm.value.number.replace(/\D/g, '');
      newGiftCard.pin = this.addGiftCardForm.value.pin;

      this.authService
        .addGiftCard(newGiftCard)
        .pipe(
           tap(() => {
                  this.toastService.showSuccess(
                    this.translocoService.translate('route.account.wallet.gift_card_added')
                  );
                }),
          mergeMap(() => this.authService.fetchGiftCardsWrapper()))
        .subscribe({
          next: () => {
            this.modalService.closeModal(ModalName.AddWallet);

            this.auditService.createAudit(() => {
              const maskedNumber = newGiftCard.number;
              return `GC with number ${maskedNumber} was applied and saved to account`;
            });
          },
          error: (err) => {
            if (!err.error) {
              this.allErrors = ['Network error'];
            } else {
              const parsedError = this.errorsService.parseErrorResponse(err);
              this.allErrors = parsedError.allErrors;
            }
          },
        });
    }
  }

  closeModal(event: Event) {
    event.preventDefault();
    this.modalService.closeModal(ModalName.AddWallet);
  }
}
